import { SafeAreaView as rSafeAreaView } from 'react-native'
import { createThemedComponent } from '../css/create-themed-component'

export const SafeAreaView = createThemedComponent(rSafeAreaView)
